// extracted by mini-css-extract-plugin
export var cardsSection = "PrecisionCare-module--cardsSection--LlS2G";
export var description = "PrecisionCare-module--description--2HP92";
export var headerSection = "PrecisionCare-module--headerSection--kFO91";
export var precisionCareWrapper = "PrecisionCare-module--precisionCareWrapper--AVOOA";
export var section = "PrecisionCare-module--section--P29l9";
export var subCardsSection = "PrecisionCare-module--subCardsSection--MQz-c";
export var subHeaderSection = "PrecisionCare-module--subHeaderSection--Ek0e9";
export var subTitle = "PrecisionCare-module--subTitle--bIj9P";
export var title = "PrecisionCare-module--title--THECi";